import { word } from "@modules/core/utils/i18n"
import { MemberTabDayToDay, MemberTabDayToDaySkeleton } from "@modules/members/components/memberTabDayToDay"
import { MemberTabProfile } from "@modules/members/components/memberTabProfile"
import { useMember } from "@modules/members/hooks/useMember"
import { MemberTabOffersLayout } from "@modules/members/memberOffers/components/memberOffersLayout"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { ErrorCard } from "@modules/ui/components/error/errorCard"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { MenuItem } from "primereact/menuitem"
import { TabMenu } from "primereact/tabmenu"
import { useTransition } from "react"

export const MemberDetailsInfo: React.FC<{
  memberId: string
}> = ({ memberId }) => {
  const { data: memberDetailed, isLoading, error } = useMember(memberId)
  const [, startTransition] = useTransition()

  const { getCurrentStackState, setCurrentStackState } = useSidebar()
  const activeIndex = getCurrentStackState("activeTabIndex") ?? 0
  const items: MenuItem[] = [
    { label: word("box.member.detailsInfo.dayToDay") },
    { label: word("box.member.detailsInfo.profile") },
    { label: word("box.member.detailsInfo.offers") },
  ]

  function selectTab(index: number) {
    startTransition(() => {
      setCurrentStackState("activeTabIndex", index)
    })
  }

  if (error) return <ErrorCard error={error} />

  return (
    <>
      {/* HEADER */}
      <HuAvatarCardSidebar
        id={memberDetailed?.userId}
        avatar={memberDetailed?.publicProfile?.avatar}
        firstname={memberDetailed?.firstname}
        lastname={memberDetailed?.lastname}
        username={memberDetailed?.username}
        prefixUsername={memberDetailed?.username ? "@" : undefined}
        nationality={memberDetailed?.publicProfile?.nationality}
        email={memberDetailed?.email}
        isLoading={isLoading}
      />
      {/* NAVIGATION TABS */}
      <div className="flex w-full mt-3">
        <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => selectTab(e.index)} className="w-full" />
      </div>
      {activeIndex === 0 &&
        !error &&
        (memberDetailed ? <MemberTabDayToDay memberDetailed={memberDetailed} /> : <MemberTabDayToDaySkeleton />)}
      {activeIndex === 1 && !error && <MemberTabProfile memberDetailed={memberDetailed} />}
      {activeIndex === 2 && !error && memberDetailed && <MemberTabOffersLayout memberDetailed={memberDetailed} />}
    </>
  )
}
